/**
 * @param {any} v
 * @returns {any}
 */
function identity(v) {
  return v;
}

export default identity;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lyjs/es/fp/identity.js
// module id = 307
// module chunks = 0